import moment from "moment";
import {
  Wrapper,
  GoalHeader,
  Head,
  Row,
  Col,
  OrderNumber,
  Heading,
  Title,
  Text,
  Badge,
  BadgeIcon
} from "./styled.js";

import completedIcon from "assets/images/journeys/completed-gray-sm.svg";

const Group = ({ data, index, renderAll }) => {
  return (
    <Wrapper>
      <GoalHeader>
        <Head>
          <OrderNumber>{index + 1}</OrderNumber>

          <Heading>
            <Title>
              <Text $area>{data?.name}</Text>
              <Text $category>{data?.goal?.category_name}</Text>
            </Title>

            <Text $goal>{data?.goal?.goal_name}</Text>
          </Heading>
        </Head>

        <Row>
          <Col>
            <Text $title>Measurement</Text>
            <Text $p>{data?.goal?.measurement_current_value ||
              data?.goal?.measurement_target_value
              ? `${data?.goal?.measurement_current_value ??
              " - "
              }/${data?.goal?.measurement_target_value ??
              " - "
              } ${data?.goal?.measurement_metric_name ?? ''}`
              : data?.goal?.measurement}</Text>
          </Col>

          <Col>
            <Text $title>ACCOUNTABILITY</Text>
            <Text $p>{data?.goal?.accountability}</Text>
          </Col>

          <Col>
            <Text $title>STARTLINE</Text>
            <Text $p>
              {data?.goal?.startline
                ? moment(data?.goal?.startline).format("MM/DD/YY")
                : ""}
            </Text>
          </Col>

          <Col>
            <Text $title>DEADLINE</Text>
            <Text $p>
              {data?.goal?.deadline
                ? moment(data?.goal?.deadline).format("MM/DD/YY")
                : ""}
            </Text>
          </Col>
        </Row>

        <Row>
          <Col $hr>
            <Text $title>REWARDS</Text>
            <Text $p>{data?.goal?.pleasure || " - "}</Text>
          </Col>

          <Col>
            <Text $title>CONSEQUENCES</Text>
            <Text $p>{data?.goal?.pain || " - "}</Text>
          </Col>
        </Row>

        <Row>
          <Col $hr>
            <Text $title>OBSTACLES</Text>
            <Text $p>{data?.goal?.obstacles || " - "}</Text>
          </Col>

          <Col>
            <Text $title>SOLUTIONS</Text>
            <Text $p>{data?.goal?.solutions || " - "}</Text>
          </Col>
        </Row>
      </GoalHeader>

      {(renderAll ? data?.goal?.actions : data?.goal?.actions?.slice(0, 2)) 
        ?.reduce((result, action, index, array) => {
          if (index % 2 === 0) result.push(array.slice(index, index + 2));
          return result;
        }, [])
        .map((actionPair, rowIndex) => (
          <Row key={rowIndex} className={rowIndex >= 1 ? "extra" : ""} $action $nowrap $extra={rowIndex >= 1 ? "extra" : ""}>
            {actionPair.map((action, colIndex) => (
              <Col
                key={colIndex}
                $half
                $hr={colIndex === 0}
              >
                <Text $title $stretch>
                  ACTION {rowIndex * 2 + colIndex + 1}
                  {action?.type ? <Badge>{action.type}</Badge> : null}
                </Text>
                <Text $p>
                  {action?.context}
                </Text>
              </Col>
            ))}
          </Row>
        ))
      }

      {data?.goal?.completed ? (
        <Row>
          <Col $hr>
            <Text $title>COMPLETION DATE</Text>
            <Text $p>
              {data?.goal?.completed_at
                ? moment(data?.goal?.completed_at).format("MM/DD/YY")
                : " - "}
            </Text>
          </Col>
          <Col $end>
            <Badge $lg>
              <BadgeIcon src={completedIcon} width={16} height={16} alt="" />
              Completed
            </Badge>
          </Col>
        </Row>
      ) : null}
    </Wrapper>
  );
};

export default Group;
